// A required field that a user focuses and then leaves empty turns the
// danger colour, in every generator form and modal, with no per-field
// wiring. A required field is an ion-input, ion-select or ion-textarea whose
// label ends in "*" (how every generator marks one) or that carries the
// required attribute. Ionic paints the outline, label and caret in
// --highlight-color-invalid once the host wears both ion-invalid and
// ion-touched; typing a value lifts the red again. Listens once at the
// document, where every field's ionBlur and ionInput bubble up.
const FIELDS = new Set(["ION-INPUT", "ION-SELECT", "ION-TEXTAREA"]);

const isField = (el) => !!el && FIELDS.has(el.tagName);
const isRequired = (el) => /\*\s*$/.test(String(el.label ?? el.getAttribute("label") ?? "")) || el.hasAttribute("required");
const isEmpty = (el) => { const v = el.value; return v === null || v === undefined || String(v).trim() === ""; };

export function installRequiredFieldHighlight() {
  if (typeof document === "undefined" || window.__requiredFieldHighlight) return;
  window.__requiredFieldHighlight = true;
  document.addEventListener("ionBlur", (e) => {
    const el = e.target;
    if (!isField(el) || !isRequired(el)) return;
    el.classList.add("ion-touched");
    el.classList.toggle("ion-invalid", isEmpty(el));
  }, true);
  const lift = (e) => {
    const el = e.target;
    if (!isField(el) || !isRequired(el)) return;
    if (!isEmpty(el)) el.classList.remove("ion-invalid");
  };
  document.addEventListener("ionInput", lift, true);
  document.addEventListener("ionChange", lift, true);
}

// The gate before a preview: marks every required field under `root` that is
// still empty (the same red the blur gives) and returns the first of them,
// or null when they are all filled. Only rendered fields count, so a folded
// section's fields do not.
export function flagEmptyRequiredFields(root) {
  if (!root) return null;
  let first = null;
  root.querySelectorAll("ion-input, ion-select, ion-textarea").forEach((el) => {
    if (!isRequired(el)) return;
    if (isEmpty(el)) {
      el.classList.add("ion-invalid", "ion-touched");
      if (!first) first = el;
    } else {
      el.classList.remove("ion-invalid");
    }
  });
  return first;
}
